/* eslint-disable camelcase */
import React from 'react'
import { Card, Typography, Input, Row, Col } from 'antd'
import PropTypes from 'prop-types'

import { RichTextContentEditor } from '~components'
// import { Checkbox } from '~stories'
import styles from './PageMetaInfo.module.css'

const PageMetaInfoWithEditor = ({
  handleDescriptionChange,
  handleHeadingChange,
  handleKeywordsChange,
  handleTextChange,
  handleTitleChange,
  // handleShowSEOChange,
  pageMeta
}) => {
  const {
    title,
    description,
    keywords,
    // should_show_seo: showSEO,
    heading,
    text
  } = pageMeta
  const { Title, Paragraph } = Typography
  return (
    <div className={styles['meta-info-container']}>
      <Card className={ styles['card-container'] }>
        <Row align={'middle'} className={styles['title-wrapper']} gutter={16} justify={'start'}>
          <Col><Title level={3}>Meta Title</Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(70 characters max; input page title and relevant keyword content that further describes page content)</Title></Col>
        </Row>
        <Row>
          <Col span={24}>
            <Input onChange={handleTitleChange} style={{ width: '100%' }} value={title} />
          </Col>
        </Row>
        <Paragraph />
      </Card>
      <Card className={ styles['card-container'] }>
        <Row align={'middle'} className={styles['title-wrapper']} gutter={16} justify={'start'}>
          <Col><Title level={3}>Meta Keywords</Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(10 keyword phrases max; input comma-separated list of keyword phrases)</Title></Col>
        </Row>
        <Row>
          <Col span={24}>
            <Input onChange={handleKeywordsChange} value={keywords} />
          </Col>
        </Row>
        <Paragraph />
      </Card>
      {/* <Card className={styles['title-wrapper']}>
        <Row align={'middle'} gutter={16} justify={'start'}>
          <Col><Title level={3}>Meta Keywords</Title></Col>
        </Row>
        <Row gutter={16}>
          <Input onChange={handleKeywordsChange} value={keywords} />
        </Row>
      </Card> */}
      <Card className={ styles['card-container'] }>
        <Row align={'middle'} className={styles['title-wrapper']} gutter={16} justify={'start'}>
          <Col><Title level={3}>Meta Description</Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(155 characters max; input brief summary of web page, using SEO-friendly keywords)</Title></Col>
        </Row>
        <Row>
          <Col span={24}>
            <RichTextContentEditor
              onChange={(description) => handleDescriptionChange(description)}
              value={description ?? ''}
            />
          </Col>
        </Row>
      </Card>
      <Card className={ styles['card-container'] }>
        <Row align={'middle'} className={styles['title-wrapper']} gutter={16} justify={'start'}>
          <Col><Title level={3}>SEO Copy Block Header</Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(155 characters max; brief SEO-friendly title of page)</Title></Col>
        </Row>
        <Row>
          <Col span={24}>
            <Input onChange={handleHeadingChange} style={{ width: '100%' }} value={heading} />
          </Col>
        </Row>
      </Card>
      <Card className={ styles['card-container'] }>
        <Row align={'middle'} className={styles['title-wrapper']} gutter={16} justify={'start'}>
          <Col><Title level={3}>SEO Copy Block Description</Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(3,000 characters max; optional passage of copy to help web page rank in external search engines)</Title></Col>
        </Row>
        <Row style={{ width: '100%' }}>
          <RichTextContentEditor
            onChange={(text) => handleTextChange(text)}
            value={text ?? ''}
          />
        </Row>
      </Card>
      {/* <Card className={ styles['card-container'] }>
        <Row align={'bottom'} gutter={16}>
          <Col span={1.5}><Title level={3}>Show SEO</Title></Col>
          <Col><Checkbox
            checked={showSEO}
            onChange={handleShowSEOChange}
          />
          </Col>
        </Row>
      </Card> */}
    </div>
  )
}

PageMetaInfoWithEditor.propTypes = {
  handleDescriptionChange: PropTypes.func,
  handleHeadingChange: PropTypes.func,
  handleKeywordsChange: PropTypes.func,
  handleShowSEOChange: PropTypes.func,
  handleTextChange: PropTypes.func,
  handleTitleChange: PropTypes.func,
  pageMeta: PropTypes.object.isRequired
}

PageMetaInfoWithEditor.defaultProps = {
  pageMeta: {}
}

export default PageMetaInfoWithEditor
